import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BASE}/api` });

// Attach staff token for KDS calls
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kds_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const dash = localStorage.getItem("dash_code");
  if (dash) config.headers["X-Dashboard-Code"] = dash;
  return config;
});

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};
